<template>
  <div
    ref="submenuTrigger"
    :class="['submenu-trigger', {'submenu-trigger--children': hasChildren}]"
  >
    <slot />
    <div
      v-if="hasChildren && !isLink"
      class="submenu-trigger__arrow"
    >
      <div :class="['icon-trigger', { 'icon-trigger--turn': active } ]">
        <span />
        <span />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { HEADER_MOBILE } from '@Foundation/constants/headermobile';
  export default {
    name: 'SubmenuTrigger',
    props: {
      menuId: { type: String, required: true },
      isLink: { type: Boolean, required: true },
      hasChildren: { type: Boolean, required: false, default: false }
    },
    data() {
      return {
        button: null,
        active: false,
        smallScreen: !window.matchMedia(`(min-width: ${HEADER_MOBILE}px)`).matches,
      };
    },
    computed: {
      ...mapGetters('menuStore', [
        'activeSubmenuId'
      ]),
    },
    watch: {
      activeSubmenuId(newId) {
        return newId === this.menuId ? this.updateSubmenu() : this.clearSubmenu();
      }
    },
    mounted() {
      this.button = this.$refs.submenuTrigger.querySelector('.btn--menu');
      this.bindEventsToButton();
      this.setAriaAttributes();
    },
    methods: {
      ...mapActions('menuStore', [
        'setActiveSubmenuId'
      ]),
      bindEventsToButton() {
        if (this.button.tagName !== 'BUTTON') {
          return;
        }
        this.button.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleSubmenu();
        });
        this.button.addEventListener('touchstart', (e) => {
          e.preventDefault();
          this.toggleSubmenu();
        });
      },
      toggleSubmenu() {
        const notThisMenu = !this.activeSubmenuId || this.activeSubmenuId !== this.menuId;
        this.setActiveSubmenuId(notThisMenu ? this.menuId : null);
      },
      updateSubmenu() {
        this.active = !this.active;
        this.setAriaExpanded();
        this.toggleClass();
      },
      clearSubmenu() {
        this.active = false;
        this.setAriaExpanded();
        this.removeClass();
      },
      toggleClass() {
        this.button.classList.toggle('btn--menu--active');
      },
      removeClass() {
        this.button.classList.remove('btn--menu--active');
      },
      setAriaExpanded() {
        if (this.button.tagName !== 'BUTTON') {
          return;
        }
        this.button.setAttribute('aria-expanded', this.active);
      },
      setAriaAttributes() {
        if (!this.smallScreen) {
          this.button.removeAttribute('aria-expanded');
          this.button.removeAttribute('aria-controls');
          if (this.button.tagName === 'BUTTON') {
            this.button.disabled = true;
            this.button.setAttribute('aria-disabled', 'true');
          }
        }
      }
    }
  };
</script>
